import { Box } from '@mui/system'
import { FC } from 'react'

interface ActivityProgressBarProps {
  currentTimeInSeconds: number
  totalTimeInSeconds: number
}

export const ActivityProgressBar: FC<ActivityProgressBarProps> = ({ currentTimeInSeconds, totalTimeInSeconds }) => {
  // check the total time to avoid division by zero edge case
  const progressPercentage = totalTimeInSeconds === 0 ? 0 : (currentTimeInSeconds / totalTimeInSeconds) * 100

  return (
    <Box
      sx={{
        height: 'var(--spacing-3xs)',
        borderRadius: 'var(--border-radius-xs)',
        backgroundColor: 'var(--shape-action-transparent)',
        position: 'relative',
        overflow: 'hidden'
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          height: '100%',
          width: `${progressPercentage}%`,
          backgroundColor: 'var(--shape-action)',
          borderRadius: 'var(--border-radius-xs)'
        }}
      />
    </Box>
  )
}
